import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Result, Spin } from "antd";
import TabViewDetails from "../../../components/TabViewDetails";
import { setTableActionDetails } from "../../../actions/tableListing/tableListDataAction";
import { getPublicO2WAuthToken } from "../../../helper/commonData";
import KnackLogo from "../../../assets/images/knackLogo.png";
import "./PublicO2WDetails.css";

const PublicO2WDetails = ({ detailsTab, type, id }) => {
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const [isReady, setIsReady] = useState(false);
  const token = searchParams.get("token") || getPublicO2WAuthToken();
  const decodedId = id ? decodeURIComponent(id) : "";

  useEffect(() => {
    if (!token) {
      setIsReady(false);
      return;
    }

    getPublicO2WAuthToken();

    const sapOrderNumber = searchParams.get("sapOrderNumber") || "";
    const labelId = searchParams.get("labelId") || decodedId;
    const valueName = searchParams.get("valueName") || decodedId;

    dispatch(
      setTableActionDetails({
        labelId,
        valueName,
        SapOrderNumber: sapOrderNumber,
      })
    );
    setIsReady(true);
  }, [token, decodedId, searchParams, dispatch]);

  if (!token) {
    return (
      <div className="public_o2w_state">
        <Result
          status="403"
          title="Invalid or missing token"
          subTitle="This public O2W details link requires a valid token."
        />
      </div>
    );
  }

  if (!isReady) {
    return (
      <div className="public_o2w_state">
        <Spin size="large" />
      </div>
    );
  }

  return (
    <div className="public_o2w_page">
      <header className="public_o2w_header">
        <img src={KnackLogo} alt="Knack" />
        <h4>Order to Warehouse (O2W) Details</h4>
      </header>
      <div className="public_o2w_content">
        <TabViewDetails detailsTab={detailsTab} type={type} id={id} />
      </div>
    </div>
  );
};

export default PublicO2WDetails;
